<template>
    <div>
        <GeoLoc @geoloc-done="handleGeoLoc" ref="GeoLoc" class="mb-3"/>

        <div class="card" v-if="(locationPermission === 'granted' || locationPermission === 'overridden')
         && !saved && !loading.geoloc">
            <h5 class="card-header">{{ $t('details') }}</h5>
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-12 col-lg-6">
                        <TextInput v-model="signerData.name" :label="$t('name')" class="font-bold"></TextInput>
                    </div>
                    <div class="col-sm-12 col-lg-6">
                        <TextInput v-model="signerData.regno" :label="$t('registration-number')" class="font-bold">
                        </TextInput>
                    </div>
                </div>
                <div class="row align-items-center">
                    <div class="col-sm-12 col-lg-6">
                        <EmailInput v-model="signerData.email" :label="$t('email')" class="font-bold"></EmailInput>
                    </div>
                    <div class="col-sm-12 col-lg-6">
                        <TextInput v-model="signerData.phone" :label="$t('phone')" class="font-bold"></TextInput>
                    </div>
                </div>

                <button class="btn btn-primary mt-2 float-right" :disabled="!(validEmail || validPhone)"
                    @click="handleSubmit">{{
                        $t('submit') }}
                </button>
            </div>
        </div>
        <div class="card" v-if="(locationPermission === 'granted' || locationPermission === 'overridden' ) && saved">
            <h5 class="card-header">{{ $t('success') }}</h5>
            <div class="card-body">
                <p>{{ $t('external-user-saved') }}</p>
            </div>
        </div>
        <div class="card" v-if="loading.geoloc">
            <h5 class="card-header">{{ $t('details') }}</h5>
            <div class="card-body">
                <table class="w-100">
                    <tr v-for="item in Array(2)" v-bind:key="item">
                        <td>
                            <div class="skeleton midnight h16 w-100 rounded mb-1"></div>
                        </td>
                        <td>
                            <div class="skeleton midnight h16 w-100 rounded mb-1"></div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

    </div>
</template>
<script>
import GeoLoc from "src/components/GeoLoc/GeoLoc";
import EmailInput from "./Inputs/EmailInput.vue";


export default {
    components: {
    GeoLoc,
    EmailInput
},
    props: [
        'formresponse',
        'ttevent_id'
    ],
    data() {
        return {
            ttevents: [],
            signerData: {
                phone: '',
                email: '',
                regno: '',
                browser: '',
                lat: '',
                long: '',
                ttevent_id: null
            },
            locationPermission: '',
            locationsLoaded: false,
            saved: false,
            loading: {
                geoloc: true
            },
            emailTyped: false
        }
    },
    mounted() {

    },
    methods: {
        eventTitle(id){
            const event = this.ttevents.filter(event => event.id == id)[0];
            return event.title
        },
        handleGeoLoc(payload) {
            this.locationPermission = payload.locationPermission;
            this.signerData.lat = payload.coords.lat;
            this.signerData.long = payload.coords.long;
            this.signerData.browser = payload.browser;
            this.loading.geoloc = payload.GeoLocLoading;
        },
        timeCheck(from, to, errorMargin) {// The error Margin should be given in minutes
            const now = new Date();
            const upperBound = new Date(to.getTime() + errorMargin * 6e4);
            const lowerBound = new Date(from.getTime() - errorMargin * 6e4);

            return (now <= upperBound && lowerBound <= now);
        },
        noEventWarning() {
            const self = this;
            const mandatory = Number(this.formresponse.workflowstage.tteventmandatory) ==1
            this.$store.commit("openDialog", {
                cancelBtn: mandatory ? false : true,
                title: this.$t("no-event"),
                content: mandatory ? this.$t("no-event-message-mandatory") : this.$t("no-event-message"),
                confirmCallBack: function () {
                    if(mandatory) return ;
                    self.saveSigner();
                }
            });
        },
        handleSubmit(){
            if(!this.ttevent_id) {
                this.noEventWarning();
            } else {
                this.saveSigner()
            }
        },
        saveSigner() {
            this.loading.geoloc = true;

            this.signerData.userfrom_id = this.$UserSession.getValue.call(this, 'id');
            this.signerData.formresponse_id = this.formresponse.formresponse_id;
            this.signerData.ttevent_id = this.ttevent_id;
            this.signerData.datetime = this.$datetime.getDateTimeLocalFieldNowValue();

            this.$cfetch(`${this.$settings.APIBaseURL}/externaluser/save`, {
                method: "post",
                data: this.signerData,
            })
                .then((res) => {
                    if (res.status === "SUCCESS") {
                        this.signerData.id = res.result.id;
                        this.$emit('external-user-saved', {
                                extuser_id: res.result.id,
                                ttevent_id: this.signerData.ttevent_id
                            }
                        );
                        this.saved = true;
                    } else {
                        if (res.error_message) {
                            this.error = res.error_message;
                        } else {
                            this.error = this.$t("problem-saving-signer");
                        }
                    }
                })
                .catch((error) => {
                    this.$log.error.call(this, error);
                })
                .finally(() =>{
                    this.loading.geoloc = false;
                });
        }
    },
    computed: {
        validPhone() {
            //const phonePattern = /^(\+447|07)\d{9}$/;
            const phonePattern = /^[0-9+]+$/;
            return phonePattern.test(this.signerData.phone);
        },
        validEmail() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.signerData.email);
        },
       
    }
}

</script>
